import { useColourScheme } from "@hooks/use-colour-scheme.ts";
import { useEffect } from "react";

export const useTheme = () => {
  const { isDarkScheme } = useColourScheme();

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkScheme);
  }, [isDarkScheme]);
};
